// Step Reference pour la Bibliographie (Version Simplifiée)
// Créé le 2025-07-02 19:46:17 UTC par HiQaody

export const BIBLIOGRAPHY_STEP_REFERENCE = {
  // === INFORMATIONS DE BASE ===
  stepId: "step3_bibliography",
  stepNumber: 3.5,
  stepName: "Bibliographie",
  stepTitle: "📚 Références bibliographiques",
  stepDescription: "Ajoutez les références bibliographiques de votre article",

  // === MÉTADONNÉES ===
  metadata: {
    createdAt: "2025-07-02 19:46:17",
    createdBy: "HiQaody",
    version: "1.0.0",
    category: "content",
    required: false,
    estimatedTime: "5-10 minutes",
  },

  // === CONFIGURATION DU CHAMP ===
  field: {
    name: "bibliography_art",
    type: "textarea",
    label: "Bibliographie",
    placeholder:
      "Saisissez vos références bibliographiques ici...\n\nExemple :\n[1] Auteur, A. (2023). Titre de l'article. Nom de la revue, 15(2), 123-145.\n[2] Nom, P. & Prénom, M. (2022). Titre du livre. Éditeur.",
    required: false,
    rows: 10,
    maxLength: 10000,
    helpText:
      "Ajoutez vos références bibliographiques une par ligne. Utilisez votre format de citation préféré (APA, IEEE, Harvard, etc.).",
  },

  // === NAVIGATION ===
  navigation: {
    previous: {
      enabled: true,
      label: "← Métadonnées",
      targetStep: "step3",
    },
    next: {
      enabled: true,
      label: "Contenu →",
      targetStep: "step4",
    },
  },

  // === AIDE RAPIDE ===
  quickHelp: [
    "Numérotez vos références : [1], [2], [3]...",
    "Incluez : auteur, titre, source, année",
    "Soyez cohérent dans le format choisi",
    "Une référence par ligne",
  ],
};

export default BIBLIOGRAPHY_STEP_REFERENCE;
